import type {
  SolicitudCarga,
  SolicitudCargaResponse,
} from "./types/solicitudCarga";

/**
 * Envía una solicitud de carga al API
 * @param data - Datos del formulario
 */
export async function postSolicitudCarga(
  data: SolicitudCarga,
): Promise<SolicitudCargaResponse> {
  try {
    const response = await fetch("/api/solicitud-carga", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const result = await response.json();

    if (!response.ok || !result.success) {
      throw new Error(result.message || `Error ${response.status}`);
    }

    return { success: true, message: "Solicitud enviada exitosamente" };
  } catch (error) {
    console.error("Error al enviar solicitud de carga:", error);
    return {
      success: false,
      message: "Error al enviar la solicitud. Intente nuevamente.",
    };
  }
}
